export default "__VITE_ASSET__Bz4Cd0eY__"